import {Component} from 'react';
import h from 'react-hyperscript';
import './Sidebar.scss';
import SidebarItem from 'Components/Cards/Sidebar/SidebarItem/SidebarItem';
import MobileMenu from 'Components/MobileMenu/MobileMenu';

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      mobileAnchorEl: null,
      isSurveyComplete: false,
    };
    this.lastStepPercentage = .88888;
    this.handleMobileMenuClose = this.handleMobileMenuClose.bind(this);
    this.handleMobileMenuOpen = this.handleMobileMenuOpen.bind(this);
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
  }

  componentDidMount() {
    this.getSelectedIndex();
    this.checkIfComplete();
  }

  componentDidUpdate(prevProps) {
    if (this.props.totalPercentComplete !== prevProps.totalPercentComplete) {
      this.checkIfComplete();
    }
  }

  checkIfComplete() {
    if (this.props.totalPercentComplete >= this.lastStepPercentage) {
      this.setIsSurveyComplete(true);
    } else {
      this.setIsSurveyComplete(false);
    }
  }

  setIsSurveyComplete(value) {
    this.setState({
      setIsSurveyComplete: value,
    });
  }

  handleMobileMenuOpen(e) {
    this.setState({
      mobileAnchorEl: e.currentTarget,
    });
  }

  handleMenuItemClick(e) {
    e.preventDefault();
    const i = parseInt(e.currentTarget.getAttribute('datatab'));
    this.props.onClick(i + 1);
  }

  handleMobileMenuClose() {
    this.setState({
      mobileAnchorEl: null,
    });
  }

  getSelectedIndex() {
    const id = `sidebar-item__${this.props.activeStep}`;
    this.props.sidebarItems.forEach((item, i) => {
      if (item.id === id) {
        this.setState({
          selectedIndex: i,
        });
      }
    });
  }

  render() {
    return (
      h('div', {
        key: 'card-sidebar__key',
        className: 'card__sidebar',
      }, [
        h(MobileMenu, {
          key: 'card-sidebar-mobile__menu',
          id: 'card-sidebar-mobile__menu',
          selectedIndex: this.state.selectedIndex,
          anchorEl: this.state.mobileAnchorEl,
          menuList: this.props.sidebarItems,
          handleMobileMenuClose: this.handleMobileMenuClose,
          handleMobileMenuOpen: this.handleMobileMenuOpen,
          changeContent: this.handleMenuItemClick,
          disableIdx: this.props.completedSteps,
        }),
        h('ul', {
          key: 'card-sidebar-list-desktop__key',
          className: 'card__sidebar-list card__sidebar-list--desktop',
        }, this.props.sidebarItems.map((item, i) => {
          const id = item.id.split('__').pop();

          return h(SidebarItem, {
            key: `${id}-sidebar__key`,
            classes: 'survey-sidebar__step',
            id: id,
            step: i,
            completedSteps: this.props.completedSteps,
            isActive: this.props.activeStep === id ? true : false,
            name: item.title,
            icon: item.icon,
            showRemaining: this.props.showRemaining,
            fieldValues: this.props.fieldValues,
            isSurveyComplete: this.state.isSurveyComplete,
            onClick: (e) => {
              e.preventDefault();
              this.props.onClick(i + 1);
            },
          }, null);
        })),
      ])
    );
  }
}

export default Sidebar;
